import React, { useState } from "react";
import { Row, Col ,message,Image,Popover} from 'antd';
import { bookcover, getbook,search } from '../../api/api'
import { useHistory } from 'react-router-dom'
import {  ArrowLeftOutlined,LoadingOutlined, SearchOutlined, UserOutlined ,CloseOutlined} from '@ant-design/icons';
import { updateSeachbooks } from '../../redux/actions/dashboardActions';
import { useSelector, useDispatch } from 'react-redux';
import {logo} from '../../api/api'
import User from '../../component/dashboard/userCard';
import PageHader from "../../component/pageheader/pageHeader";
import { FiSearch} from "react-icons/fi";
import Space from '../../component/dashboard/space';

import './styles.css';

const Searchscreen = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isloading, setisloading] = useState(false)
    const [ismoreloading, setismoreloading] = useState(false)
    const [ismoredata, setismoredata] = useState(true)
    const searchbooksvalues = useSelector((state) => state.App.searchbooksvalues);
    const [text, settext] = useState(searchbooksvalues.searchtext)
    const [visible, setvisible] = useState(false)
    const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));
    const showuser = useSelector((state) => state.App.showlogin);

    const handleVisibleChange = visible => {
        setvisible(visible)
      };
    const getBooksList = async () => {
        message.destroy()
        let url = search;
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        fetch(url+"q="+searchbooksvalues.searchtext+"&sort=recentold", requestOptions,)
            .then(response => response.json())
            .then(result => {
                if(result.pagination.count==0){
                    setismoredata(false)
                    message.warning('No Data Found ');

                }else{
                    dispatch(updateSeachbooks(searchbooksvalues.books.concat(result.data), searchbooksvalues.pagination + 20, text))

                }
                setisloading(false)
                setismoreloading(false)

            })
            .catch(error => {
                setisloading(false)
                setismoreloading(false)
            });

    }
    const login = () => {
        history.replace('./login');
    }
     

    const onSearch = () => {
        message.destroy()
        console.log(text.length)
        if (text.length==0) {
            message.warning('Please fill the search box');

        }else{
            dispatch(updateSeachbooks([], 0, text))
            setismoredata(true)
            setisloading(true)
            getBooksList()
        }
    }

    const onClear = () => {
        settext("")
        dispatch(updateSeachbooks([], 0, ""))

    }

    const loademore = () => {
        setismoreloading(true)
        getBooksList()
    }

    const updatetext = event => {
        settext(event.target.value)
    }
    
    const handleAnswerChange=(event)=>{
                message.destroy()

        console.log(event.key)
        if (event.key=="Enter") {
            if (text.length==0) {
                message.warning('Please fill the search box');
    
            }else{
                dispatch(updateSeachbooks([], 0, text))
                setismoredata(true)
                setisloading(true)
                getBooksList()
            }

        } 
		
	
}
const trancateTitle= (title)=> {
    try{
        var length = 20;
        if (title.length > length) {
           title = title.substring(0, length)+'...';
        }
        return title;
    }catch{
        return title;

    }
    
}
const goToDeacriton = (item) => {
   
    history.push({pathname:'/book/isbn/'+ item.identifier,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})

     
    
    }


    return (
        <div className="continer">
                                   <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

                                      <PageHader titel={"Search"} hideicon={true}/>    
                                   <div className="searchinput-s">
                    <div className='searchbox'>
                    <FiSearch onClick={onSearch} className='searchicon-s' />                   
                   {isloading && <LoadingOutlined className='loadingicon-s'/>}
                        <input autoFocus={true} onKeyPress={handleAnswerChange}   type="search"   className="searchboxfiled-s" placeholder="What are you looking for?" name="search"  value={text} onChange={updatetext}   />
                         </div>
                </div>
            {searchbooksvalues.books.length > 0 ? 
           <div className="cards-container listcontiner">
             <div className='list-result'>
                  <p className='resulttext'>Results({searchbooksvalues.books.length})</p>
                  <p className='cleartext' onClick={()=>{onClear()}}><span style={{marginRight:'2px'}}>Clear</span><CloseOutlined/></p>

                  </div>
           {searchbooksvalues.books.map((item) => {
             return (
               <div className="ion-card" onClick={() => { goToDeacriton(item) }}>
                 <div className="bookcover_continer">
                   <Image className="bookcover"
                    preview={false}
                     fallback="data:image/png;base64,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"
                     src={bookcover + item.fuzzyId + "/" + item.cover} />
                 </div>
                 <div className="bookcontent">
 
                   <div>
                     <div className="booktitle" >{item.name}</div>
                     <div className='card-sub'>{item.subTitle}</div>
                   {"authors" in item &&  <div className='card-auth'>{item.authors.map(item => item.surName + " " + item.givenName).toString().replaceAll(",", ", ")}</div>}
                   </div>
 
 
 
 
                 </div>
               </div>
 
             )
           })}
           <Space hig="10px" color="#ffffff" />
 
         </div>
            :
                <div className="nodata">
                    Search by Title,Author,ISBN,Series,Collection,Publisher or subject
                </div>}
                </Col>
        </div>
    );
}


export default Searchscreen;